module.exports = __webpack_public_path__ + "img/blog-40.88ea2105.jpg";